import { forwardRef } from 'react';
import { DialogContent } from './dialog';
import { cn } from 'lib/utils';
import './public-dialog.css';

// Public popups opt in to this material; the existing admin/customer dialog defaults stay intact.
export const PublicDialogContent = forwardRef(({ className, overlayClassName, ...props }, ref) => (
  <DialogContent
    ref={ref}
    className={cn('public-dialog', className)}
    overlayClassName={cn('public-dialog-overlay', overlayClassName)}
    data-public-dialog=""
    {...props}
  />
));
PublicDialogContent.displayName = 'PublicDialogContent';
